import { notifyOpusWebCodecsUnsupportedOnce } from './opusHead';
import { OpusWasmUpstreamEncoder } from './opusWasmUpstreamEncoder';
import { OpusWebCodecsUpstreamEncoder } from './opusWebCodecsUpstreamEncoder';

export type OpusEncodedPacketHandler = (
  opusPacket: ArrayBuffer,
) => void | Promise<void>;

export interface OpusUpstreamEncoder {
  ensureConfigured(): Promise<boolean>;
  feedStereoS16le48k(audioData: ArrayBuffer): void;
  flush(): Promise<void>;
  close(): void;
  isConfigured(): boolean;
}

/**
 * 优先使用浏览器原生 WebCodecs；不可用或不支持 Opus 时，懒加载 WASM libopus。
 */
export async function createOpusUpstreamEncoder(
  onEncoded: OpusEncodedPacketHandler,
): Promise<OpusUpstreamEncoder | null> {
  const webCodecs = new OpusWebCodecsUpstreamEncoder(onEncoded);
  if (await webCodecs.ensureConfigured()) {
    return webCodecs;
  }
  webCodecs.close();

  const wasm = new OpusWasmUpstreamEncoder(onEncoded);
  if (await wasm.ensureConfigured()) {
    return wasm;
  }
  wasm.close();

  notifyOpusWebCodecsUnsupportedOnce();
  return null;
}
